import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Pathless layout — renders children (index + onboarding) via Outlet. */
export const Route = createFileRoute('/_authenticated/_tenant/platform/subsidiaries')({
  component: () => <Outlet />,
});
